module.exports = __webpack_public_path__ + "static/img/frame 4.bc0d5d71.png";